import jsonLdBlog from './blog';

function getJsonLdPosting({
  headline,
  url,
  description,
  image,
  authorName,
  dateCreated,
  dateModified,
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    '@id': url || null,
    ...(url ? { url } : {}),
    ...(headline ? { headline } : {}),
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName
      ? {
        author: {
          '@type': 'Person',
          name: authorName,
        },
      }
      : {}),
    ...(dateCreated ? { dateCreated } : {}),
    ...(dateModified ? { dateModified } : {}),
    isPartOf: jsonLdBlog,
  };
}

export default getJsonLdPosting;
